import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "menu"];

  connect() {
    this.header = this.element;
  }

  toggle() {
    if (this.header.classList.contains("elevate")) {
      this.header.classList.remove("elevate");
    } else {
      this.header.classList.add("elevate");
    }

    // Detect when dropdown is closed (Bootstrap dropdown behavior)
    document.addEventListener("click", (event) => {
      if (!this.menuTarget.contains(event.target) && !this.toggleTarget.contains(event.target)) {
        this.header.classList.remove("elevate");
      }
    });
  }
}
